import React, { FC, useContext } from 'react';
import classes from './LicenseHasExpiredModal.module.scss';
import { createPortal } from 'react-dom';
import classNames from 'classnames';
import { ClientLicenseWarningIcon } from '../../../assets/icons';
import { LicenseContext } from '../../../context/LisenceContext/LicenseContext';
import Typography, { TypographyVariant } from '../../Typography/Typography';
import modalBase from '../../ModalBase/ModalBase.module.scss';

export const ClientLicenseHasExpiredModal: FC = () => {
  const { isLicenseExpired, currentLicenseKey } = useContext(LicenseContext);

  return (
    <>
      {isLicenseExpired &&
        createPortal(
          <div
            className={classNames(
              modalBase.modal,
              modalBase.active,
              classes.licenseHasExpiredModalWrapper,
              classes.client,
            )}
          >
            <div className={classNames(modalBase.container, classes.contentContainer)}>
              <ClientLicenseWarningIcon className={classes.warningIcon} />

              <Typography
                variant={TypographyVariant.h1_semibold_client}
                className={classes.importantText}>
                Срок действия лицензии истек
              </Typography>
              <Typography variant={TypographyVariant.h3_semibold_client}>
                {currentLicenseKey
                  ? 'За продлением лицензии обратитесь в ООО Техно-Скай'
                  : 'Обратитесь к администратору или в ООО "Техно-Скай"'}
              </Typography>

              <button
                type="button"
                onClick={() => window.location.reload()}
                className={classes.reloadButton}>
                <Typography variant={TypographyVariant.h2_semibold_client} tagName="span">
                  Обновить
                </Typography>
              </button>
            </div>
          </div>,
          document.body
        )}
    </>
  );
};
